const TOPICS = [
  { label: '韩漫', count: '12,800+', hot: true },
  { label: '日漫', count: '15,600+', hot: true },
  { label: '国漫', count: '8,900+', hot: true },
  { label: '悬疑漫画', count: '3,200+', hot: true },
  { label: '恋爱漫画', count: '6,500+', hot: false },
  { label: '搞笑漫画', count: '4,100+', hot: false },
  { label: '奇幻漫画', count: '5,300+', hot: false },
  { label: '都市漫画', count: '3,800+', hot: false },
  { label: '古风漫画', count: '2,900+', hot: false },
  { label: '校园漫画', count: '4,500+', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            探索你最感兴趣的漫画品类
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100 hover:border-primary-300 text-primary-700'
                  : 'bg-background-50 border-background-200/70 hover:bg-background-100 hover:border-primary-200 text-foreground-700'
              }`}
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-fill text-accent-500 text-sm"></i>
                </span>
              )}
              <span className="text-sm font-medium">{topic.label}</span>
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}